export const LARGE_DL_MEMBER_COUNT: number = 100;
export const INDIVIDUAL_RECIPIENT_MEMBER_COUNT: number = 1;
export const PUBLIC_DL: string = 'PublicDL';
export const PRIVATE_DL: string = 'PrivateDL';
export const GROUP_MAILBOX: string = 'GroupMailbox';
export const RECOMMENDED_GROUP: string = 'RecommendedGroup';
export const INTERNAL_MAILBOX: string = 'InternalMailbox';
export const EXTERNAL_MAILBOX: string = 'ExternalMailbox';
export const MAILBOX: string = 'Mailbox';
export const ONE_OFF: string = 'OneOff';
export const CONTACT: string = 'Contact';
export const IMPLICIT_CONTACT: string = 'ImplicitContact';
export const PUBLIC_FOLDER: string = 'PublicFolder';
export const OTHER: string = 'Other';
export const ROOM: string = 'Room';
export const LINKED_IN: string = 'LinkedIn';
